import Components from "slotworks/components/components";
import Idle from "slotworks/state-machine/standard/states/idle";

export default class GameiomRecovery extends Idle {

    public onEnter() {
        gameWrapper.setBusy();

        Components.footer.showFreespinStart();

        this.complete();
    }
}
